import { render, staticRenderFns } from "./RevenueBottomClient.vue?vue&type=template&id=1a5eab4a&"
import script from "./RevenueBottomClient.vue?vue&type=script&lang=js&"
export * from "./RevenueBottomClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports